import { ProgressSpinner } from 'primereact/progressspinner';

export const Loader = () => {
  return (
    <div className="flex justify-content-center align-items-center h-30rem">
      <ProgressSpinner />
    </div>
  );
};
